import { render, staticRenderFns } from "./Pagintacion.vue?vue&type=template&id=3249adf2&"
import script from "./Pagintacion.vue?vue&type=script&lang=js&"
export * from "./Pagintacion.vue?vue&type=script&lang=js&"
import style0 from "./Pagintacion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports